export const paymentMethodTypes = {
  BANK: 'BANK',
  CARD: 'CARD',
  PAY_INTERNAL: 'PAY_INTERNAL',
  WALLET: 'WALLET',
} as const;

export type PaymentMethodTypes = (typeof paymentMethodTypes)[keyof typeof paymentMethodTypes];

export const paymentMethodCodes = {
  AFFIRM: 'Affirm',
  ALIPAY_CN: 'AlipayCN',
  ALIPAY_HK: 'AlipayHK',
  APPLE_PAY: 'ApplePay',
  APP_CARD: 'AppCard',
  BANCONTACT: 'Bancontact',
  CARD: 'CARD',
  DUMMY_BANK: 'IBE',
  GOOGLE_PAY: 'GooglePay',
  IDEAL: 'IDeal',
  KAKAOPAY: 'KakaoPay',
  KLARNA_ONE: 'OneKlarna',
  KLARNA_PAY_LATER: 'KlarnaPayLater',
  KLARNA_PAY_NOW: 'KlarnaPayNow',
  KLARNA_SLICE_IT: 'KlarnaSliceIt',
  KLARNA_SOFORT: 'KlarnaSofortuberweisung',
  NAVERPAY: 'NaverPay',
  ONLINE_BANKING_PL: 'OnlineBankingPl',
  PAYPAL: 'PayPal',
  PAYPAL_PAY_LATER: 'PayPalPayLater',
  PIX: 'Pix',
  SOFORT: 'Sofort',
  TRUSTLY: 'Trustly',
  UPI: 'Upi',
  VOLT: 'Volt',
  TWINT: 'Twint',
} as const;

export type PaymentMethodCode = (typeof paymentMethodCodes)[keyof typeof paymentMethodCodes];
